import { AppComposer } from "./providers/app-composer";

function App() {
  return <AppComposer />;
}

export default App;
